export const CONFIRMATION_BASE_PATH = '/orders/confirmation/:orderId/:adId(\\d+)';
export const CONFIRMATION_MAP_PATH = `${CONFIRMATION_BASE_PATH}/map`;
export const CONFIRMATION_PATH = `${CONFIRMATION_BASE_PATH}/:map?`;
